import { Unit } from '@elderbyte/ngx-starter'
import { PropertySpec } from '../../../properties/spec/property-spec'

export class ProcessingTimeSpec extends PropertySpec {
  public setNumber: number // frontend-only. will be translated to groups of arrays

  public id: string
  public unit: Unit
  public description: string
}
